import { combineReducers } from "@reduxjs/toolkit";

import { Authorization } from "./Authorization";
import { Staging } from "./Staging";
import { Clone } from "./Clone";
import { Delete } from "./Delete";
import { Export } from "./Export";
import { IState } from "../../Model/State/IState";
import { Omikron } from "./Omikron";
import { Projects } from "./Projects";
import { UI } from "./UI";

export const rootReducer = combineReducers<IState>({
  authorization: Authorization,
  clone: Clone,
  delete: Delete,
  export: Export,
  omikron: Omikron,
  projects: Projects,
  ui: UI,
  staging: Staging
});
